import LocalizedStrings from 'react-localization';

let strings = new LocalizedStrings({

    en: {
        seo: {
            title: 'Progress in progress',
            definition:'2022-2025 EQUITY, DIVERSITY AND INCLUSION PLAN',
            tagline:"We are committed to creating the personal, relevant, and engaging experiences that Canadians expect.",
            description: "Progress in Progress - CBC/Radio-Canada’s Equity, Diversity and Inclusion Plan accelerates our work to reflect Canada in our content and workforce.",
            creds: "© 2021 CBC/Radio-Canada. All rights reserved."

        },
        general: {
            callToAction1: "Register Now!",
            tag: "NotOk",
            contact: "cbc.radio-canada@cbc.ca",
            more: "Read More",
            lang: "FR",
            currentLang: "EN",
            notFound: "404 – page not found.",
            home: "HOME",
        },
        pause: "Pause",
        play:"Play"
        
    },
    fr: {
        seo: {
            title: 'Cap sur le succès',
            definition:'Plan sur l’équité, la diversité et l’inclusion 2022-2025',
            tagline:"Nous sommes résolus à créer des expériences uniques, pertinentes et engageantes qui répondent aux attentes de la population canadienne.",
            description: "Cap sur le succès - le plan de CBC/Radio-Canada sur l’équité, la diversité et l’inclusion accélère notre désir d’incarner le Canada dans nos contenus et notre effectif.",
            creds: "© 2021 CBC/Radio-Canada. Tous droits réservés"


        },
        general: {
            callToAction1: "Inscrivez-vous maintenant!",
            tag: "CestAssez",
            contact: "cbc.radio-canada@cbc.ca",
            more: "En savoir plus",
            lang: "EN",
            currentLang: "FR",
            notFound: "404 – Page introuvable",
            home: "ACCUEIL",
        },
        pause: "Pause",
        play:"Jouer"
    }
});

export default strings;